"use client";

import { ReactNode } from "react";
import { ReactQueryProvider } from "@/providers/ReactQueryProvider";

export default function Providers({ children }: { children: ReactNode }) {
  return <ReactQueryProvider>{children}</ReactQueryProvider>;
}
